import React from 'react';
import { Button, Form, Modal, Space, Input } from 'antd';
import { FormWrapper } from 'common/components/form-wrapper/form-wrapper';
import { IModal } from 'common/models/model.interface';
import { RuleType } from 'rc-field-form/lib/interface';
import { ValidationMessages } from 'common/validation/validation-messages';

const TrafficReportExportModal = ({ title, isEdit, initData, isOpen, onClose }: IModal<any, any>) => {
  const [form] = Form.useForm();

  const hideModal = (...rest: any) => {
    form.resetFields();
    if (onClose) {
      onClose(...rest);
    }
  };

  const onFinish = (values: any) => {
    hideModal(true, values.email);
  };

  return (
    <Modal centered title={title} width={350} open={isOpen} closable={false} wrapClassName="custom-modal" onCancel={() => hideModal(false)}>
      <FormWrapper form={form} onFinish={onFinish} layout="vertical">
        <Space className="full-width" size={13}>
          <Form.Item name="email" label="Email address" rules={formRules.email}>
            <Input placeholder="Enter email" />
          </Form.Item>
        </Space>
        <Space className="footer">
          <Button type="link" onClick={() => hideModal(false)}>
            Cancel
          </Button>
          <Button htmlType="submit" type="primary">
            Send
          </Button>
        </Space>
      </FormWrapper>
    </Modal>
  );
};

export default React.memo(TrafficReportExportModal, (prevProps, nextProps) => {
  return prevProps.isOpen === nextProps.isOpen;
});

const formRules = {
  email: [
    { required: true, message: 'Email is required!' },
    { message: ValidationMessages.Email.NotValidMessage, type: 'email' as RuleType },
  ],
};
